import { ApiResponse } from "utils/types/API";
import { AmountType, ConversionResponse } from "utils/types/PricingTypes";
import { ApiService } from "../apiservices";
import { apiSrcUrl } from "../ApiRoutes";
// Import the correct types from the new pricing module

/**
 * Calls the currency conversion API endpoint.
 * @param amountType The type of amount being sent ('bsbCoinAmount', 'usdAmount', or 'localCurrencyAmount').
 * @param amountValue The numeric value of the amount.
 * @param currencyCode The target local currency code (e.g., 'CDF').
 * @returns A promise that resolves to the API response containing the converted amounts.
 */
export const convertCurrencyAPI = async (
  amountType: AmountType,
  amountValue: number,
  currencyCode: string
): Promise<ApiResponse<ConversionResponse>> => {
  const url = `${apiSrcUrl}/public/price/convertor/${currencyCode}`;
  const body = {
    amountType,
    amountValue,
  };


  const { data } = await ApiService.post<ApiResponse<ConversionResponse>>(
    url,
    body
  );
  return data;
};
